import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]

import { computed } from 'vue'

interface Props {
  /** Field label for accessibility */
  label?: string | null
  /** Error message to display */
  error: string
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'BaseError'
},
  __name: 'BaseError',
  props: {
    label: { default: null },
    error: {}
  },
  setup(__props: any) {





const accessibleError = computed(() => {
  if (__props.label) {
    return `${__props.label}: ${__props.error}`
  }
  return __props.error
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    class: "error-message block",
    role: "alert",
    "aria-label": accessibleError.value
  }, _toDisplayString(__props.error), 9, _hoisted_1))
}
}

})